module.exports = {"manageMyAccount":{"production":"https://customer.safeco.com/accountmanager/account/login","development":"https://customer.qa.safeco.com/accountmanager/tacml/customeraccountmanager/account/login","localhost":"https://customer.qa.safeco.com/accountmanager/tacml/customeraccountmanager/account/login","test":"https://customer.qa.safeco.com/accountmanager/tacml/customeraccountmanager/account/login","qa":"https://customer.qa.safeco.com/accountmanager/tacml/customeraccountmanager/account/login"}}


//////////////////
// WEBPACK FOOTER
// ./src/settings/links.json
// module id = 264
// module chunks = 0